<template>
    <main class="cooperative-customers-container">
        <CaterawayHeader/>
        <section class="cooperative-customers-main">
            <div class="img-contanier">
                <div class="big-screen" v-if="windowWidth > 1600">
                    <div class="image-box"></div>
                    <el-image class="image-position" :src="require('@/assets/images/client-bannger.png')" :fit="fit" :lazy="true"></el-image>
                </div>
                <div class="small-screen" v-else>
                    <el-image style="width: 100%;height: 100%;" :src="require('@/assets/images/client-bannger.png')" fit="cover" :lazy="true"></el-image>
                </div>
            </div>
            <div class="customers-activity-contanier">
                <div class="activity-main">
                    <Title :title="$t('message.clinetContent.partTitleOne')"></Title>
                    <Content :content="$t('message.clinetContent.partContentOne')"></Content>
                    <div class="activity-content-main">
                        <div v-for="(item,index) in activity" :key="index" class="activity-item">
                            <div class="activity-item-img">
                                <el-image class="item-img" :src="item.img" fit="cover" :lazy="true"></el-image>
                            </div>
                            <div>
                                <h5 class="activity-item-content">{{item.name}}</h5>
                                <p class="activity-item-span">{{ $t("message.clinetContent.activity.activityService") }}{{item.service}}</p>
                                <p class="activity-item-span">  {{ $t("message.clinetContent.activity.activityNumber") }}{{item.number}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="customers-container">
                <Title :title="$t('message.hezuo.h2')"></Title>
                <div class="customers-main">
                    <div class="customers-item" v-for="(item,index) in customers" :key="index">
                        <img :src="item.url" alt />
                        <div class="name">{{ $i18n.locale == 'en' ? item.nameEn:item.nameZh }}</div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import CaterawayHeader from "@/components/header";
import Title from '../../components/common/title.vue'
import Content from '../../components/common/content.vue'
export default {
    components:{
        CaterawayHeader,
        Title,
        Content
    },
    data() {
        return {
            fit:'contain',
            windowWidth: document.documentElement.clientWidth,
            banner:'https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/60%E4%BA%BA%E4%BB%BD%E6%B4%BE%E5%AF%B9%E5%A5%97%E9%A4%90%E5%B0%81%E9%9D%A2.png',
            activity:[
                {
                    img:require("@/assets/images/partImageOne.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleOne"),
                    service:this.$t("message.clinetContent.activity.partServiceOne"),
                    number:1000
                },
                {
                    img:require("@/assets/images/partImageTwo.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleTwo"),
                    service:this.$t("message.clinetContent.activity.partServiceTwo"),
                    number:80
                },
                {
                    img:require("@/assets/images/partImageThree.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleThree"),
                    service:this.$t("message.clinetContent.activity.partServiceThree"),
                    number:100
                },
                {
                    img:require("@/assets/images/partImageFour.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleFour"),
                    service:this.$t("message.clinetContent.activity.partServiceThour"),
                    number:40
                },
                {
                    img:require("@/assets/images/partImageFive.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleFive"),
                    service:this.$t("message.clinetContent.activity.partServiceFive"),
                    number:150
                },
                {
                    img:require("@/assets/images/partImageSix.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleSix"),
                    service:this.$t("message.clinetContent.activity.partServiceSix"),
                    number:200
                },
            ],
            customers:[
                {
                    nameZh: "18+ Central",
                    nameEn: "18+ Central",
                    url: require("@/assets/images/client1_img.png")
                },
                {
                    nameZh: "AIA",
                    nameEn: "AIA",
                    url: require("@/assets/images/client28_img.png")
                },
                {
                    nameZh: "東區尤德夫人 那打素醫院",
                    nameEn: "Pamela Youde Nethersole Eastern Hospital",
                    url: require("@/assets/images/client3_img.png")
                },
                {
                    nameZh: "東亞銀行",
                    nameEn: "The Bank of East Asia",
                    url: require("@/assets/images/client4_img.png")
                },
                {
                    nameZh: "富衛香港",
                    nameEn: "FWD Life Insurance Company (Bermuda) Limited",
                    url: require("@/assets/images/client5_img.png")
                },
                {
                    nameZh: "基督教聯合醫院",
                    nameEn: "United Christian Hospital",
                    url: require("@/assets/images/client6_img.png")
                },
                {
                    nameZh: "建造業議會",
                    nameEn: "Construction Industry Council",
                    url: require("@/assets/images/client7_img.png")
                },
                {
                    nameZh: "將軍澳醫院",
                    nameEn: "Tseung Kwan O Hospital",
                    url: require("@/assets/images/client8_img.png")
                },
                {
                    nameZh: "救世軍",
                    nameEn: "The Salvation Army",
                    url: require("@/assets/images/client9_img.png")
                },
                {
                    nameZh: "老夫子慈善跑2019",
                    nameEn: "Pokoi Charity Run 2019",
                    url: require("@/assets/images/client10_img.png")
                },
                {
                    nameZh: "瑪麗醫院",
                    nameEn: "Queen Mary Hospital",
                    url: require("@/assets/images/client11_img.png")
                },
                {
                    nameZh: "如心酒店",
                    nameEn: "L'hotel",
                    url: require("@/assets/images/client12_img.png")
                },
                {
                    nameZh: "四季酒店",
                    nameEn: "Four Seasons",
                    url: require("@/assets/images/client13_img.png")
                },
                {
                    nameZh: "香港城市大學",
                    nameEn: "City University of Hong Kong",
                    url: require("@/assets/images/client14_img.png")
                },
                {
                    nameZh: "香港大學",
                    nameEn: "The University of Hong Kong",
                    url: require("@/assets/images/client15_img.png")
                },
                {
                    nameZh: "香港復康會",
                    nameEn: "The Hong Kong Society for Rehabilitation",
                    url: require("@/assets/images/client16_img.png")
                },
                {
                    nameZh: "香港海關",
                    nameEn: "Customs and Excise Department",
                    url: require("@/assets/images/client17_img.png")
                },
                {
                    nameZh: "香港會議展覽中心",
                    nameEn: "Hong Kong Convention and Exhibition Centre",
                    url: require("@/assets/images/client18_img.png")
                },
                {
                    nameZh: "香港科技大學 商學院",
                    nameEn: "HKUST Business School",
                    url: require("@/assets/images/client19_img.png")
                },
                {
                    nameZh: "香港小童群益會",
                    nameEn: "The Boys' and Girls' Clubs Association of Hong Kong",
                    url: require("@/assets/images/client20_img.png")
                },
                {
                    nameZh: "香港音樂及藝術節",
                    nameEn: "Clockenflap",
                    url: require("@/assets/images/client21_img.png")
                },
                {
                    nameZh: "香港中文大學 醫學院",
                    nameEn: "CUHK Faculty of Medicine",
                    url: require("@/assets/images/client22_img.png")
                },
                {
                    nameZh: "香港足球總會",
                    nameEn: "Hong Kong Football Association",
                    url: require("@/assets/images/client23_img.png")
                },
                {
                    nameZh:"協康會",
                    nameEn: "Heep Hong Society",
                    url: require("@/assets/images/client24_img.png")
                },
                {
                    nameZh: "醫院管理局",
                    nameEn: "Hospital Authority",
                    url: require("@/assets/images/client25_img.png")
                },
                {
                    nameZh: "怡和科技",
                    nameEn: "Jardine OneSolution",
                    url: require("@/assets/images/client26_img.png")
                },
                {
                    nameZh: "英國保誠+ Prudential",
                    nameEn: "Prudential",
                    url: require("@/assets/images/client27_img.png")
                },
                {
                    nameZh: "帝京酒店",
                    nameEn: "Royal Plaza Hotel",
                    url: require("@/assets/images/client2_img.png")
                },
                {
                    nameZh: "Amazon",
                    nameEn: "Amazon",
                    url: require("@/assets/images/client29_img.png")
                },
                {
                    nameZh: "Deutsche Bank",
                    nameEn: "Deutsche Bank",
                    url: require("@/assets/images/client30_img.png")
                },
                {
                    nameZh: "GAP",
                    nameEn: "GAP",
                    url: require("@/assets/images/client31_img.png")
                },
                {
                    nameZh:"IFC",
                    nameEn: "IFC",
                    url: require("@/assets/images/client32_img.png")
                },
                {
                    nameZh: "Kooza",
                    nameEn: "Kooza",
                    url: require("@/assets/images/client33_img.png")
                },
                {
                    nameZh: "Maersk",
                    nameEn: "Maersk",
                    url: require("@/assets/images/client34_img.png")
                },
                {
                    nameZh: "Menulife",
                    nameEn: "Menulife",
                    url: require("@/assets/images/client35_img.png")
                },
                {
                    nameZh: "PWC",
                    nameEn: "PWC",
                    url: require("@/assets/images/client36_img.png")
                },
                {
                    nameZh: "Sports Federation _ Olympic Committee of Hong Kong",
                    nameEn: "Sports Federation _ Olympic  Committee of Hong Kong",
                    url: require("@/assets/images/client37_img.png")
                },
                {
                    nameZh: "volvo-ocean-race",
                    nameEn: "volvo-ocean-race",
                    url: require("@/assets/images/client38_img.png")
                }
            ]
        }
    },
    watch:{
        '$i18n.locale'(){
            this.activity = [
                {
                    img:require("@/assets/images/partImageOne.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleOne"),
                    service:this.$t("message.clinetContent.activity.partServiceOne"),
                    number:1000
                },
                {
                    img:require("@/assets/images/partImageTwo.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleTwo"),
                    service:this.$t("message.clinetContent.activity.partServiceTwo"),
                    number:80
                },
                {
                    img:require("@/assets/images/partImageThree.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleThree"),
                    service:this.$t("message.clinetContent.activity.partServiceThree"),
                    number:100
                },
                {
                    img:require("@/assets/images/partImageFour.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleFour"),
                    service:this.$t("message.clinetContent.activity.partServiceThour"),
                    number:40
                },
                {
                    img:require("@/assets/images/partImageFive.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleFive"),
                    service:this.$t("message.clinetContent.activity.partServiceFive"),
                    number:150
                },
                {
                    img:require("@/assets/images/partImageSix.jpg"),
                    name:this.$t("message.clinetContent.activity.partTitleSix"),
                    service:this.$t("message.clinetContent.activity.partServiceSix"),
                    number:200
                },
            ]
        }
    },
    mounted(){
        window.addEventListener("resize", () => {
            this.windowWidth = document.documentElement.clientWidth;
        });
    }
}
</script>

<style lang="less" scoped>
.cooperative-customers-container {
    .cooperative-customers-main {
        height: 100%;
        margin-top: 110px;
        @media all and (max-width: 480px) {
            margin-top: 135px;
        }
        .img-contanier{
            width: 100%;
            height: 100%;
            .big-screen {
                width: 100%;
                display: flex;
                align-items: center;
                overflow: hidden;
                .image-box {
                    width: 100%;
                    height: 548px;
                    max-height: 548px;
                    overflow: hidden;
                    @media all and (max-width: 850px) {
                        height: 300px;
                    }
                }
                .image-position { 
                    width: 100%;
                    position: absolute;
                    z-index: -2;
                }
            }
            .small-screen {
                width: 100%;
                height: 548px;
                max-height: 548px;
                @media all and (max-width: 850px) {
                    height: 300px;
                }
            }
        }

        .customers-activity-contanier{
            background: #fff;
            .activity-main{
                width:70%;
                padding:3% 2%;
                margin:0 auto;
                @media (max-width: 1255px) {
                    width: 90%;
                }
                .activity-content-main{
                    display: flex;
                    justify-content: space-around;
                    flex-wrap: wrap;
                    @media (max-width: 768px) {
                        flex-wrap: wrap;
                        justify-content: space-between;
                    }
                    .activity-item{
                        text-align: center;
                        flex:0 0 30%;
                        @media (max-width: 768px) {
                            flex:0 0 48%;
                        }
                        @media (max-width: 480px) {
                            flex:0 0 100%;
                            display:flex;
                            text-align: left;
                        }
                        .activity-item-img{
                            .item-img{
                                width:100%;
                                height:100%;
                                min-height: 285px;
                            }
                            @media (max-width: 480px) {
                                flex:0 0 48%;
                            }
                        }
                        .activity-item-content,.activity-item-span{
                            margin: 20px;
                        }
                        .activity-item-content{
                            text-align: left;
                            font-size: 1rem;
                            font-weight: 550;
                            @media (max-width: 1200px) {
                            font-size: 2vw;
                            }
                            @media (max-width: 768px) {
                            font-size: 3.2vw;
                            }
                            @media (max-width: 480px) {
                            font-size: 4.2vw;
                            }
                        }
                        .activity-item-span{
                            text-align: left;
                            font-size:14px;
                            color:#919599;
                            font-weight: 350;
                        }
                        .item-button{
                            @media (max-width: 480px) {
                            margin:0 20px;
                            }
                        }
                    }
                }
            }
        }
        .customers-container {
            
            .customers-main {
                width: 75%;
                margin:  0 auto;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                .customers-item {
                    box-sizing: border-box;
                    flex: 0 0 25%;
                    margin-bottom: 8%;
                    text-align: center;
                    img {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>